/* The few icons the shared layer uses, inline so they ship with the app and
 * take the text color. Each is decorative beside a word or an aria-label, so
 * a screen reader skips it. */

const base = {
  width: 16, height: 16, viewBox: "0 0 24 24", fill: "none",
  stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round",
  "aria-hidden": true, focusable: false,
} as const;

/** The magnifier, for a search box. */
export function IconSearch() {
  return (
    <svg {...base}>
      <circle cx="11" cy="11" r="7" />
      <path d="M21 21l-4.3-4.3" />
    </svg>
  );
}

/** The funnel, for the filters. */
export function IconFilter() {
  return (
    <svg {...base}>
      <path d="M3 5h18l-7 8v6l-4 2v-8L3 5z" />
    </svg>
  );
}

/** A globe, for looking on the web. */
export function IconGlobe() {
  return (
    <svg {...base}>
      <circle cx="12" cy="12" r="9" />
      <path d="M3.6 9h16.8M3.6 15h16.8" />
      <path d="M11.5 3a17 17 0 0 0 0 18M12.5 3a17 17 0 0 1 0 18" />
    </svg>
  );
}

/** A contact card, for asking a contact source such as Apollo. */
export function IconContactCard() {
  return (
    <svg {...base}>
      <rect x="3" y="4" width="18" height="16" rx="3" />
      <circle cx="9" cy="10" r="2" />
      <path d="M15 8h2M15 12h2M7 16h10" />
    </svg>
  );
}

/** A clipboard with a list, for a request someone works. */
export function IconClipboard() {
  return (
    <svg {...base}>
      <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
      <rect x="9" y="3" width="6" height="4" rx="2" />
      <path d="M9 12h.01M13 12h2M9 16h.01M13 16h2" />
    </svg>
  );
}

/** A clipboard with a check, for finishing a request. */
export function IconClipboardCheck() {
  return (
    <svg {...base}>
      <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
      <rect x="9" y="3" width="6" height="4" rx="2" />
      <path d="M9 14l2 2l4-4" />
    </svg>
  );
}

/** A page of notes, for notes a person writes. */
export function IconNotes() {
  return (
    <svg {...base}>
      <rect x="5" y="3" width="14" height="18" rx="2" />
      <path d="M9 7h6M9 11h6M9 15h4" />
    </svg>
  );
}

/** A download arrow, for a file to take away. */
export function IconDownload() {
  return (
    <svg {...base}>
      <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />
      <path d="M7 11l5 5l5-5M12 4v12" />
    </svg>
  );
}

/** A left arrow, before a link that goes back. */
export function IconArrowLeft() {
  return (
    <svg {...base}>
      <path d="M19 12H5M11 18l-6-6l6-6" />
    </svg>
  );
}

/** A check, for a step that is done. */
export function IconCheck() {
  return (
    <svg {...base}>
      <path d="M5 12l5 5l9-10" />
    </svg>
  );
}

/** Two arrows in a circle, for something that repeats on its own. */
export function IconRepeat() {
  return (
    <svg {...base}>
      <path d="M4 12a8 8 0 0 1 13.7-5.7L20 8.6" />
      <path d="M20 4v4.6h-4.6" />
      <path d="M20 12a8 8 0 0 1-13.7 5.7L4 15.4" />
      <path d="M4 20v-4.6h4.6" />
    </svg>
  );
}
